import { render, staticRenderFns } from "./add_assess.vue?vue&type=template&id=b431971c&scoped=true"
import script from "./add_assess.vue?vue&type=script&lang=js"
export * from "./add_assess.vue?vue&type=script&lang=js"
import style0 from "./add_assess.vue?vue&type=style&index=0&id=b431971c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b431971c",
  null
  
)

export default component.exports